const SignIn = () => {
  window.location.href = `https://sso-frontend.devorchin.com/?client=63982e825f725625a9fbeef1&role=manager`;

  return <></>;
};

export default SignIn;
